import {ClauseAtom, DocumentSection} from "common/types/document";
import sortClausesByDocumentOrder from "utils/clauses/sort_clauses_by_document_order";

function findFirstApplicableClause(
  clauses: ClauseAtom[],
  documentSections: DocumentSection[],
): ClauseAtom | null {
  if (!clauses || clauses.length === 0) {
    return null;
  }
  return sortClausesByDocumentOrder(clauses, documentSections, true)[0];
}

export default findFirstApplicableClause;
